module.exports = __webpack_public_path__ + "static/media/facebook-logo.7bc6d556.svg";